var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAtom = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.5355 8.46394C20.2218 13.1502 22.4379 18.5321 20.4852 20.4848C18.5326 22.4374 13.1507 20.2213 8.46443 15.535C3.77814 10.8487 1.56206 5.46681 3.51468 3.51419C5.4673 1.56157 10.8492 3.77765 15.5355 8.46394Z",
    stroke: "#068FF9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.0005H12.01M15.5355 15.536C10.8492 20.2223 5.4673 22.4384 3.51468 20.4857C1.56206 18.5331 3.77814 13.1512 8.46443 8.46492C13.1507 3.77863 18.5326 1.56255 20.4852 3.51517C22.4379 5.46779 20.2218 10.8497 15.5355 15.536ZM12.5 12.0005C12.5 12.2766 12.2761 12.5005 12 12.5005C11.7238 12.5005 11.5 12.2766 11.5 12.0005C11.5 11.7243 11.7238 11.5005 12 11.5005C12.2761 11.5005 12.5 11.7243 12.5 12.0005Z",
    stroke: "#068FF9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAtom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Atom.d186f1ef98e6e61d433fe34840e1a2dd.svg";